import React, { useState, useEffect } from "react";
import Modal from "./Modal";
import Field from "./Field";

function AddInstrumentModal({
  data, // { teamId, userId, username }
  onClose,
  onSubmit,
  fetchChallenges,
  fetchInstruments,
}) {
  const [challenges, setChallenges] = useState([]);
  const [instruments, setInstruments] = useState([]);
  const [selectedChallengeId, setSelectedChallengeId] = useState("");
  const [selectedInstrumentId, setSelectedInstrumentId] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    async function loadData() {
      try {
        setLoading(true);
        const [challengesData, instrumentsData] = await Promise.all([
          fetchChallenges(),
          fetchInstruments(),
        ]);
        setChallenges(challengesData);
        setInstruments(instrumentsData);
      } catch (e) {
        setErr("خطا در بارگذاری اطلاعات");
      } finally {
        setLoading(false);
      }
    }
    loadData();
  }, [fetchChallenges, fetchInstruments]);

  function validate() {
    if (!selectedChallengeId) return "انتخاب چالش الزامی است";
    if (!selectedInstrumentId) return "انتخاب ساز الزامی است";
    return "";
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const v = validate();
    if (v) return setErr(v);

    setErr("");
    setSubmitting(true);

    try {
      await onSubmit(
        data.teamId,
        selectedChallengeId,
        data.userId,
        selectedInstrumentId
      );
      onClose();
    } catch (e) {
      setErr(e.message || "خطا در تنظیم ساز");
    } finally {
      setSubmitting(false);
    }
  }

  if (!data) return null;

  return (
    <Modal title={`افزودن ساز برای ${data.username}`} onClose={onClose}>
      <form onSubmit={handleSubmit} className="space-y-4 text-right">
        {err && <div className="text-red-400 text-sm">{err}</div>}

        {loading ? (
          <div className="text-center py-8 text-gray-400">
            در حال بارگذاری...
          </div>
        ) : (
          <>
            <Field label="انتخاب چالش">
              <select
                value={selectedChallengeId}
                onChange={(e) => setSelectedChallengeId(e.target.value)}
                className="w-full rounded-xl bg-gray-800 border border-gray-700 text-gray-200 px-3 py-2 focus:outline-none focus:border-emerald-500"
              >
                <option value="">— انتخاب کنید —</option>
                {challenges.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.title || c.name || `چالش ${c.id}`}
                  </option>
                ))}
              </select>
            </Field>

            <Field label="انتخاب نماد">
              <select
                value={selectedInstrumentId}
                onChange={(e) => setSelectedInstrumentId(e.target.value)}
                className="w-full rounded-xl bg-gray-800 border border-gray-700 text-gray-200 px-3 py-2 focus:outline-none focus:border-emerald-500"
              >
                <option value="">— انتخاب کنید —</option>
                {instruments.map((inst) => (
                  <option key={inst.id} value={inst.id}>
                    {inst.instrument || `نماد ${inst.id}`}
                  </option>
                ))}
              </select>
            </Field>

            {selectedChallengeId && selectedInstrumentId && (
              <div
                className="rounded-xl border p-4"
                style={{
                  borderColor: "rgba(16,185,129,0.4)",
                  backgroundColor: "rgba(16,185,129,0.08)",
                }}
              >
                <p className="text-emerald-300 text-sm">
                  ✅ آماده ثبت ساز برای{" "}
                  <span className="font-semibold">{data.username}</span>
                </p>
              </div>
            )}

            <div className="flex justify-end gap-3 pt-2">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 rounded-xl text-gray-200 border"
                style={{
                  borderColor: "rgba(55,65,81,0.6)",
                  backgroundColor: "rgba(17,24,39,0.6)",
                }}
              >
                انصراف
              </button>
              <button
                type="submit"
                disabled={submitting}
                className={`px-4 py-2 rounded-xl text-white ${
                  submitting ? "opacity-70" : ""
                }`}
                style={{ backgroundColor: "#10b981" }}
              >
                {submitting ? "در حال ثبت..." : "✓ ثبت ساز"}
              </button>
            </div>
          </>
        )}
      </form>
    </Modal>
  );
}

export default AddInstrumentModal;
